export const DATE_MINIMUM_YEAR = 1900;
export const DATE_MAXIMUM_YEAR = 9999;
export const DATE_FORMAT = 'YYYY/MM/DD';
